import { apiURL, works } from '../config';
import { ProjectsResponse } from '../models/page';

export const fetchProjects = async (
  current_lang: string = '',
  current_page?: number
): Promise<ProjectsResponse> => {
  return fetch(
    `${apiURL}${current_lang}${works}${
      current_page ? `?page=${current_page}` : ''
    }`
  )
    .then((res) => res.json())
    .catch((e) => Promise.reject(e));
};
